var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 0.875C6.97337 0.875 5.79699 1.36228 4.92963 2.22963C4.06228 3.09699 3.575 4.27337 3.575 5.5V8.075H1.1C0.976 8.075 0.875 8.175 0.875 8.3V11.7C0.875 11.824 0.975 11.925 1.1 11.925H3.575V18.9C3.575 19.024 3.675 19.125 3.8 19.125H7.2C7.324 19.125 7.425 19.025 7.425 18.9V11.925H9.922C10.025 11.925 10.115 11.855 10.14 11.755L10.99 8.355C10.9984 8.32182 10.9991 8.28717 10.992 8.25369C10.985 8.22021 10.9704 8.18877 10.9494 8.16178C10.9283 8.13478 10.9014 8.11293 10.8707 8.09789C10.84 8.08286 10.8062 8.07503 10.772 8.075H7.425V5.5C7.425 5.39823 7.44505 5.29745 7.48399 5.20342C7.52294 5.10939 7.58003 5.02396 7.65199 4.95199C7.72396 4.88003 7.80939 4.82294 7.90342 4.78399C7.99745 4.74505 8.09823 4.725 8.2 4.725H10.8C10.924 4.725 11.025 4.625 11.025 4.5V1.1C11.025 0.976 10.925 0.875 10.8 0.875H8.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.447d3f26e47c87a1bdd0489b2e6be517.svg";
export { ForwardRef as ReactComponent };